import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuHeaderComponent } from './components/menu-header/menu-header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { Pet24snackbarComponent } from './components/pet24snackbar/pet24snackbar.component';
import { AppointmentComponent } from './components/appointment/appointment.component';
import { TestbackendComponent } from './components/testbackend/testbackend.component';
import { AppointmentVeterinariaComponent } from './components/appointment-veterinaria/appointment-veterinaria.component';
import { OkcancelDialogComponent } from './components/okcancel-dialog/okcancel-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import { CardInfoVetComponent } from './components/card-info-vet/card-info-vet.component';
import { PublicyCardsComponent } from './components/publicy-cards/publicy-cards.component';
import { MapVeterinariasComponent } from './components/map-veterinarias/map-veterinarias.component';
import { MenuGestionCitasClientComponent } from './components/menu-gestion-citas-client/menu-gestion-citas-client.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { LiveStatusComponent } from './components/live-status/live-status.component';
import { AdvertisementCarouselComponent } from './components/advertisement-carousel/advertisement-carousel.component';
import { PublicidadPopupDialogComponent } from './components/publicidad-popup-dialog/publicidad-popup-dialog.component';
@NgModule({
  declarations: [
    MenuHeaderComponent,
    FooterComponent,
    Pet24snackbarComponent,
    AppointmentComponent,
    AppointmentVeterinariaComponent,
    TestbackendComponent,
    OkcancelDialogComponent,
    CardInfoVetComponent,
    PublicyCardsComponent,
    MapVeterinariasComponent,
    MenuGestionCitasClientComponent,
    LiveStatusComponent,
    AdvertisementCarouselComponent,
    PublicidadPopupDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSlideToggleModule,
    FormsModule
  ],
  exports: [
    MenuHeaderComponent,
    FooterComponent,
    AppointmentComponent,
    TestbackendComponent,
    OkcancelDialogComponent,
    CardInfoVetComponent,
    PublicyCardsComponent,
    MapVeterinariasComponent,
    MenuGestionCitasClientComponent,
    LiveStatusComponent,
    AdvertisementCarouselComponent,
    PublicidadPopupDialogComponent
  ]
})
export class SharedModule { }
